export interface WicketAdminBillingItem {
  start_time: string;
  end_time: string;
  send: WicketAdminBillingSubTotal;
  campaign: WicketAdminBillingSubTotal;
}

export interface WicketAdminBillingSubTotal {
  usage_amount: number;
  charge_amount: WicketAdminBillingPrice;
}

interface WicketAdminBillingPrice {
  amount: number;
  currency_code: string;
}
